import { lazy } from "react";
import { RouteObject } from "react-router-dom";

import { SidebarLayout } from "@layouts";

const HomePage = lazy(() => import("@pages/home"));
const DetailedAnalysisPage = lazy(() => import("@pages/detailedAnalysis"));
const PeriodAnalysisPage = lazy(() => import("@pages/periodAnalysis"));
const NotFoundPage = lazy(() => import("@pages/NotFound"));
const FirstSettingsPage = lazy(() => import("@pages/settings"));
const UserSettingsPage = lazy(() => import("@pages/userSettings"));
const AnalysisByPeriodPage = lazy(() => import("@pages/vsMarket/analysisByPeriod"));
const DetailedAnalysisVSMarketPage = lazy(() => import("@pages/vsMarket/detailedAnalysis"));
const CustomerServiceCenterPage = lazy(() => import("@pages/customerService"));


const UserRoutes: RouteObject[] = [
  {
    path: "/",
    element: <SidebarLayout />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/detailed-analysis/:reviewId?",
        element: <DetailedAnalysisPage />,
      },
      {
        path: "/period-analysis",
        element: <PeriodAnalysisPage />,
      },
      {
        path: "/detailed-analysis",
        element: <DetailedAnalysisPage />,
      },
      /*{
        path: "/detailed-analysis-by-period",
        element: <DetailedAnalysisVSMarketPage />,
      },
      {
        path: "/analysis-by-period",
        element: <AnalysisByPeriodPage />,
      },*/
      {
        path: "/settings",
        element: <UserSettingsPage />,
      },
      {
        path: "/first-settings",
        element: <FirstSettingsPage />,
      },
      {
        path: "/customer-service-center",
        element: <CustomerServiceCenterPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />
      }
      
    ],
  },
];

export default UserRoutes;
